'use client';

import { useMemo } from 'react';
import { Provider } from 'react-redux';
import { makeStore } from '@/lib/store';

export default function StoreProvider({ children, user }) {
    const store = useMemo(() => {
        const preloadedState = user ? { user: { user } } : {};

        return makeStore(preloadedState);
    }, [user?.uid]);

    return <Provider store={store}>{children}</Provider>;
}
